function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChase = function SvgChase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1957a3"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.461 7.342a.845.845 0 0 0-.844.844v6.248h16.634l-7.599-7.093h-8.191m16.212 9.12a.845.845 0 0 0-.844-.844h-6.248v16.634l7.177-7.515v-8.275m-9.204 16.212a.845.845 0 0 0 .844-.844v-6.248H7.849l7.515 7.177h8.19M7.342 23.554c0 .507.422.844.844.844h6.248V7.849l-7.093 7.515v8.19",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgChase;